import React, { useMemo } from "react";
import styled from "styled-components";
import ConfigData from "../../../config/ca-config-json.json";

const MainContainer = styled.div`
  border: 1px dashed #cacaca;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 20px;
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 100px;
`;

const DocumentPreview = ({ contentType, contentData }) => {
  const getYoutubeThumbnail = (url, quality) => {
    if (url) {
      var video_id, thumbnail, result;
      if ((result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/))) {
        video_id = result.pop();
      } else if ((result = url.match(/youtu.be\/(.{11})/))) {
        video_id = result.pop();
      }

      if (video_id) {
        if (typeof quality == "undefined") {
          quality = "high";
        }

        let quality_key = "maxresdefault"; // Max quality
        if (quality === "low") {
          quality_key = "sddefault";
        } else if (quality === "medium") {
          quality_key = "mqdefault";
        } else if (quality === "high") {
          quality_key = "hqdefault";
        }

        thumbnail =
          "http://img.youtube.com/vi/" + video_id + "/" + quality_key + ".jpg";
        return thumbnail;
      }
    }
    return null;
  };

  const imgData = useMemo(() => {
    if (contentType === ConfigData.documentTypes.youtube.value) {
      const thumbnail = getYoutubeThumbnail(contentData, "high");
      return thumbnail;
    }
    return contentData;
  }, [contentData, contentType]);

  return (
    <MainContainer>
      {imgData && (
        <img
          src={imgData}
          style={{
            width: "100%",
            objectFit: "contain",
            height: "100%",
            backgroundColor: "#F4F4F4",
            cursor: "zoom-in",
          }}
          alt={"img"}
          onLoad={() => {}}
          onClick={() => {}}
        />
      )}
    </MainContainer>
  );
};

export default DocumentPreview;
